import { FC, useContext } from "react";

import { Typography } from "antd";
import { Card } from "@hdi-seguros/web-components.card";

import { GenericDataFormContext } from "../../contexts/GenericDataForm";

import './index.css';

interface PreliquidationLoadingCardProps {
    isResume?: boolean;
}

export const PreliquidationLoadingCard: FC<PreliquidationLoadingCardProps> = ({ isResume = false }) => {
    const { preliquidationInfo } = useContext(GenericDataFormContext);

    return (
        <Card className="preliquidation-loading-card-container">
            <Typography>
                {
                    isResume
                        ? `Aguarde un momento, estamos cargando la preliquidación ${preliquidationInfo?.numeroPreliquidacion }`
                        : 'Espere un momento. Estamos creando la preliquidación. No cierre esta ventana'
                }
            </Typography>
        </Card>
    );
};